"use client";

import { usePathname } from "next/navigation";

export default function LayoutContent({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isAuthLayout = pathname === "/login" || pathname.startsWith("/login/");

  if (isAuthLayout) {
    return <>{children}</>;
  }

  return (
    <section className="body-wrapper p-2">
      <div className="main-content">{children}</div>
    </section>
  );
}
